export const ACTION_TYPES = {
  LOAD: 'badge/LOAD',
  RESET: 'badge/RESET',
  MARK_AS_SEEN: 'badge/MARK_AS_SEEN',
};

const initialState = {
  loading: false,
  badges: [],
  notseenBadges: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ACTION_TYPES.LOAD + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        badges: action.payload.data.badges,
        notseenBadges: action.payload.data.badges.filter(
          it => !it.seen && it.level > 0,
        ),
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
